export default __webpack_public_path__ + "static/media/fi.acde026c.jpg";